import CryptoJS from "crypto-js";
import { fromUrlSafeBase64 } from "./tools";

export const AUTH_STORAGE_CLEARED_EVENT = "auth-storage-cleared";

const BLOCKWATCH_TOKEN_QUERY = "skysp";
const BLOCKWATCH_TOKEN_KEY = "ky@bky9y8l9b7t6";

/**
 * 在应用挂载前接收官网传给 BlockWatch 的登录 token。
 * 这样路由守卫、顶部导航和工作台页面首次渲染时能读取到同一份登录态。
 */
export function consumeBlockWatchToken() {
  if (typeof window === "undefined") return false;

  const url = new URL(window.location.href);
  const encryptedToken = url.searchParams.get(BLOCKWATCH_TOKEN_QUERY);
  if (!encryptedToken) return false;

  let restored = false;
  try {
    const standardToken = fromUrlSafeBase64(encryptedToken);
    const token = CryptoJS.AES.decrypt(
      standardToken,
      BLOCKWATCH_TOKEN_KEY,
    ).toString(CryptoJS.enc.Utf8);

    if (token && !isJwtExpired(token)) {
      localStorage.setItem("token", token);
      restored = true;
    }
  } catch (error) {
    restored = false;
  } finally {
    // token 只消费一次，避免敏感参数继续保留在地址栏和浏览器历史中。
    url.searchParams.delete(BLOCKWATCH_TOKEN_QUERY);
    window.history.replaceState(
      window.history.state,
      document.title,
      `${url.pathname}${url.search}${url.hash}`,
    );
  }

  return restored;
}

export function isJwtExpired(token, now = Date.now()) {
  if (!token || typeof token !== "string") return true;

  try {
    const parts = token.split(".");
    if (parts.length !== 3) return true;

    const payloadBase64 = parts[1]
      .replace(/-/g, "+")
      .replace(/_/g, "/")
      .padEnd(Math.ceil(parts[1].length / 4) * 4, "=");
    const payload = JSON.parse(window.atob(payloadBase64));
    const expiresAt = Number(payload.exp) * 1000;

    return !Number.isFinite(expiresAt) || expiresAt <= now;
  } catch (error) {
    return true;
  }
}

export function clearAuthStorage(reason = "expired") {
  const hadAuth =
    !!localStorage.getItem("userInfo") || !!localStorage.getItem("token");

  localStorage.removeItem("userInfo");
  localStorage.removeItem("token");

  if (hadAuth && typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent(AUTH_STORAGE_CLEARED_EVENT, {
        detail: { reason },
      }),
    );
  }
}
